export const END_OF_SERVICE_REWARD_CALCULATION_LOAD = 'END_OF_SERVICE_REWARD_CALCULATION_LOAD'
export const END_OF_SERVICE_REWARD_CALCULATION_LOAD_PENDING =
  'END_OF_SERVICE_REWARD_CALCULATION_LOAD_PENDING'
export const END_OF_SERVICE_REWARD_CALCULATION_LOAD_FULFILLED =
  'END_OF_SERVICE_REWARD_CALCULATION_LOAD_FULFILLED'
export const END_OF_SERVICE_REWARD_CALCULATION_LOAD_REJECTED =
  'END_OF_SERVICE_REWARD_CALCULATION_LOAD_REJECTED'

export const END_OF_SERVICE_REWARD_CALCULATION_UPDATE = 'END_OF_SERVICE_REWARD_CALCULATION_UPDATE'
export const END_OF_SERVICE_REWARD_CALCULATION_UPDATE_PENDING =
  'END_OF_SERVICE_REWARD_CALCULATION_UPDATE_PENDING'
export const END_OF_SERVICE_REWARD_CALCULATION_UPDATE_FULFILLED =
  'END_OF_SERVICE_REWARD_CALCULATION_UPDATE_FULFILLED'
export const END_OF_SERVICE_REWARD_CALCULATION_UPDATE_REJECTED =
  'END_OF_SERVICE_REWARD_CALCULATION_UPDATE_REJECTED'
